import moment from 'moment'
import $store from '@/store'

export default {
  data () {
    return {
      constants: {
        units: {
          GRAM: {
            'value': 'g',
            'text': 'g',
            'step': 50,
            'multiplierAmount': 1,
            'startAmount': 50
          },
          HGRAM: {
            'value': '100g',
            'text': '100g',
            'step': 50,
            'multiplierAmount': 100,
            'startAmount': 50
          },
          KGRAM: {
            'value': '1000g',
            'text': 'kg',
            'step': 50,
            'multiplierAmount': 1000,
            'startAmount': 50
          },
          PIECE: {
            'value': 'pcs',
            'text': 'St.',
            'step': 1,
            'multiplierAmount': 1,
            'startAmount': 1
          }
        }
      }
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('DD.MM.YYYY')
    },
    formatDateTime (date) {
      return moment(date).format('DD.MM.YYYY hh:mm')
    },
    formatLabels (labels) {
      var str = ''
      for (var i = 0; i < labels.length; i += 1) {
        if (i < labels.length - 1) {
          str += labels[i].name + ', '
        } else {
          str += labels[i].name
        }
      }
      return str
    },
    formatType (type) {
      if (type === 'catalog') {
        return ' (Webshop)'
      } else if (type === 'live') {
        return ' (Live Bestellung)'
      }
    },
    formatPrice (item, string) {
      var res = ''
      if (item && item.currency) {
        switch (string) {
          case 'unit':
            res = this.formatCents(item.price_per_unit) + ' ' + item.currency.symbol
            break
          case 'nettoSum':
            res = this.formatCents(item.net_price) + ' ' + item.currency.symbol
            break
          case 'bruttoSum':
            res = this.formatCents(item.price) + ' ' + item.currency.symbol
            break
        }
      }
      return res
    },
    formatAmount (item) {
      return item.amount + ' ' + this.getAmountLabel(item.unit)
    },
    getAmountLabel (unit) {
      var lab = this.constants.units.GRAM.text
      switch (unit) {
        case this.constants.units.PIECE.value: {
          lab = this.constants.units.PIECE.text
          break
        }
      }
      return lab
    },
    getMaxForItem (item) {
      return item.product && (item.product.current_stock !== null && item.product.current_stock >= 0) ? item.product.current_stock : $store.getters.options_get_max_posible_stock
    },
    canCheckout (updatingCart, cart) {
      return !updatingCart && ((cart.type === 'live') || (cart.cartItems && cart.cartItems.meta && cart.cartItems.meta.price >= cart.shop.min_order_value))
    },
    getStartAmount (unit) {
      var a = this.constants.units.GRAM.startAmount
      switch (unit) {
        case this.constants.units.PIECE.value: {
          a = this.constants.units.PIECE.startAmount
          break
        }
      }
      return a
    },
    getStepAmount (unit) {
      var a = this.constants.units.GRAM.step
      switch (unit) {
        case this.constants.units.PIECE.value: {
          a = this.constants.units.PIECE.step
          break
        }
      }
      return a
    },
    calculatePriceFromUnit (amount, priceUnit, unit) {
      var m = this.constants.units.GRAM.multiplierAmount
      switch (unit) {
        case this.constants.units.PIECE.value: {
          m = this.constants.units.PIECE.multiplierAmount
          break
        }
        case this.constants.units.HGRAM.value: {
          m = this.constants.units.HGRAM.multiplierAmount
          break
        }
        case this.constants.units.KGRAM.value: {
          m = this.constants.units.KGRAM.multiplierAmount
          break
        }
      }
      return (amount / m) * priceUnit
    },
    getTextFromUnit (unit) {
      var text = ''
      for (var i in this.constants.units) {
        if (this.constants.units[i].value === unit) {
          text = this.constants.units[i].text
          break
        }
      }
      return text
    },
    getCarrierPrice (total, carrier) {
      var cost = 0
      for (var fromRange in carrier.costs) {
        if (total < fromRange) {
          break
        }
        cost = carrier.costs[fromRange]
      }
      return cost
    },
    taxTextFormat (cart) {
      if (cart.cartItems.data.length > 0) return 'inkl. ' + cart.cartItems.data[0].tax_percent + '% MwSt'
    },
    totalTaxFormat (cart) {
      if (cart.cartItems.meta) return this.formatCents(cart.cartItems.meta.tax_price) + ' ' + cart.shop.currency.symbol
    },
    totalNettoPriceFormat (cart) {
      if (cart.cartItems.meta) return this.formatCents(cart.cartItems.meta.net_price) + ' ' + cart.shop.currency.symbol
    },
    totalPriceFormat (cart) {
      if (cart.cartItems.meta) return this.formatCents(cart.cartItems.meta.price) + ' ' + cart.shop.currency.symbol
    },
    totalCarrierPrice (cart, carrier) {
      return this.formatCents(this.getCarrierPrice(cart.cartItems.meta.price, carrier)) + ' ' + cart.shop.currency.symbol
    },
    totalPriceCheckoutFormat (cart, carrier) {
      var carrierPrice = this.getCarrierPrice(cart.cartItems.meta.price, carrier)
      return this.formatCents(cart.cartItems.meta.price + carrierPrice) + ' ' + cart.shop.currency.symbol
    },
    getOrderPrice (price, shop) {
      return this.formatCents(price) + ' ' + shop.currency.symbol
    },
    formatCents (val) {
      val = val / 100
      return val.toFixed(2)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/formatting.js